import React, {useContext,useMemo, useReducer, useState} from "react";
import {Link, useHistory, useLocation, useParams} from "react-router-dom";
import { updateSegment } from "../../services/globalService";
import StateContext from "../../context/StateContext";
import ToggleButton from "../utils/ToggleButton";
import ContentBox from "../../move2FComponents/ContentBox";
import SaveButton from "../../move2FComponents/SaveButton";
import { ReactComponent as LeftArrow } from "../../img/Left_Arrow.svg";
import { ReactComponent as ErrorIcon } from "../../img/ErrorIcon.svg";
import {
    StyledGoBack,
    StyledInBoxFrame,
    StyledInBoxFrameHeader,
    StyledSmallError,
    StyledInputContainerInline, StyledLabelLarge, StyledGreyInput
} from "../style/global.style";
import { StyledInnerPage } from "./setup.style";
import SmallLoader from "../../components/utils/SmallLoader";
import {updateSegmentInData} from "../../services/dataService";
import { captureException } from "services/sentry";
import {ReactComponent as GoogleIconSmall} from "../../img/GoogleIcon_small.svg";
import Tooltip from "../utils/Tooltip";
import {ReactComponent as QuestionIcon} from "../../img/Question_icon.svg";
import {validateUA} from "../../services/analytics";

const stateReducerFunc = (state, action) => {
    if (action.type === "ua") return { ...state, ua: action.payload };
    if (action.type === "gapi" && state.gapi) return { ...state, ua: "", gapi: false };
    return { ...state, [action.type]: !state[action.type] };
};

const ConnectGoogle = () => {
    const { segMap, segments, ACTIONS, dispatch } = useContext(StateContext);
    const { code } = useParams();
    const history = useHistory();
    const [showSpinner, setShowSpinner] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const location = useLocation();
    const prevLocation = useMemo(() => {
        return location.pathname.replace("/google", "");
    }, [location]);

    const initValue = useMemo(
        () =>
            segMap && segMap[code]?.install_data?.options
                ? { ...segMap[code].install_data.options, ua: segMap[code].install_data.ua }
                : { gapi: false, fb: false, pt: false, ms: false, tb: false, ua: "", ob: false },
        [code, segMap]
    );
    const [options, dispatchOptions] = useReducer(stateReducerFunc, initValue);


    const togglePlatform = (e) => {
        dispatchOptions({ type: e.target.name });
    };

    const prepInstallData = () => {
        const newInstallData = { ...segMap[code].install_data };
        if (options.ua) newInstallData.ua = options.ua;
        if (!options.gapi && newInstallData.ua) newInstallData.ua = "";
        newInstallData.options.gapi = options.gapi;
        return newInstallData;
    };

    const onSave = async () => {
        setShowSpinner(true);
        if (options.gapi && !validateUA(options.ua)) {
            setErrorMessage("Invalid UA number");
            setTimeout(() => setErrorMessage(""), 4000);
            return;
        }
        let payload = {};
        // update the segment only if have code
        try {
            const res = await updateSegment({id: code, data: {install_data: prepInstallData()}});
            if (res?.data) {
                const newSegment = res.data;
                const {newSegments, newMap} = updateSegmentInData(newSegment, segments, segMap);
                payload = {segments: newSegments, segMap: newMap};
                dispatch({type: ACTIONS.SET_STATE, payload});
                setShowSpinner(false);
                history.push(prevLocation);
            }
        }catch (e){
            setErrorMessage(e.message);
            dispatch({ type: ACTIONS.SET_CODE, payload: null });
            console.error("CreateSegment.js ~ saveName ~ error", e);
            setTimeout(() => {
                setErrorMessage("");
                setShowSpinner(false);
                history.push(prevLocation);
            }, 2000);
            captureException(e, "error", {}, { action: "onSave", description: "failed saving changes on platforms" }, { scope: "connectPlatforms.js" });
        }
    }

    return (
        <StyledInnerPage>
            <StyledGoBack disabled={showSpinner} as={Link} onClick={() => history.goBack()}>
                <LeftArrow />
                Go Back
            </StyledGoBack>
            <ContentBox title="Reach high value users with Google analytics">
            <p>Fixel automagically integrates with your favorite ad platforms for creating high value audiences.</p>
                <StyledInBoxFrame>
                    <StyledInBoxFrameHeader>
                        <h3>
                            <GoogleIconSmall />
                            Google Analytics (for Google Ads)
                        </h3>
                        <ToggleButton name="gapi" disabled={showSpinner} onChange={togglePlatform} isChecked={options.gapi} />
                    </StyledInBoxFrameHeader>
                    {options.gapi ? (
                        <StyledInputContainerInline>
                            <StyledLabelLarge>
                                Paste your Google Analytics UA: *{" "}
                                <Tooltip content='The tracking ID is located on the "Property Settings" page in Google Analytics'>
                                    <QuestionIcon />
                                </Tooltip>
                            </StyledLabelLarge>
                            <StyledGreyInput
                                disabled={showSpinner}
                                placeholder="UA-123456-78"
                                type="text"
                                name="ua"
                                id="ua"
                                value={options.ua}
                                onChange={(e) => dispatchOptions({ type: e.target.name, payload: e.target.value })}
                            />
                        </StyledInputContainerInline>
                    ) : null}
                </StyledInBoxFrame>
                {errorMessage ? (
                    <StyledSmallError>
                        <ErrorIcon />
                        {errorMessage}
                    </StyledSmallError>
                ) : null}
                <SaveButton
                    type="button"
                    onClick={onSave}
                    disabled={!code || (options.gapi && !options.ua) || showSpinner}
                    label={showSpinner ? <SmallLoader inline={true} /> : "Save"}
                    alignTo="left"
                />
            </ContentBox>
        </StyledInnerPage>
    );
};
export default ConnectGoogle;
